import { useAnimatedNumber } from '../hooks/useAnimatedNumber';

/** Contador animado: formatea el valor interpolado en cada frame. */
export function AnimatedNumber({
  value,
  format,
  durationMs,
}: {
  value: number;
  format: (value: number) => string;
  durationMs?: number;
}) {
  const animated = useAnimatedNumber(value, durationMs);
  return <>{format(animated)}</>;
}
